"use client";

import { useEffect, useState, useMemo } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { fetchAdminLiveTeam, fetchWorkspaces } from "../../api/api";
import Congratulations from "../../mycomp/Dashboard/HelpDesk/Congratulations";
import OutlineRoundedButtons from "../../mycomp/UIKit/Buttons/OutlineRoundedButtons";

const MyTeam = () => {
  const [members, setMembers] = useState([]);
  const [filter, setFilter] = useState("all");
  const navigate = useNavigate();

const handleMemberClick = (member) => {
  if (!workspaces.length) {
    console.warn("Workspaces not loaded yet");
  }

  const workspace = workspaces.find(
    w => String(w.id) === String(member.workspace_id)
  );

  console.log("Clicked member:", member);
  console.log("Matched workspace:", workspace);

  navigate("/dashboard/personal-statistics", {
    state: {
      user_id: member.user_id,
      name: member.name,
      email: member.email,
      workspace_name: workspace?.name || "No Workspace"
    }
  });
};

  // Workspace state
  const [workspaces, setWorkspaces] = useState([]);
  const [workspaceId, setWorkspaceId] = useState(null);

  // Fetch team members
  useEffect(() => {
    fetchAdminLiveTeam().then(res => {
      setMembers(res.members || []);
    });
  }, []);

  // Fetch workspaces
  useEffect(() => {
    const loadWorkspaces = async () => {
      const data = await fetchWorkspaces(); // add user id if needed
      setWorkspaces(data || []);
      if (data?.length) setWorkspaceId(data[0].id); // default selection
    };
    loadWorkspaces();
  }, []);

  // Filter members based on workspace and status
  const filteredMembers = useMemo(() => {
    let list = members || [];

    // Filter by selected workspace
    if (workspaceId) {
      list = list.filter(m => m.workspace_id === workspaceId);
    }

    // Filter by status
    switch (filter) {
      case "working":
        list = list.filter(m => m.status === "working");
        break;

      case "meeting":
        list = list.filter(m => m.status === "meeting");
        break;

      case "break":
        list = list.filter(m => m.status === "break");
        break;
      case "not_started":
        list = list.filter(m => !m.start_time);
        break;
      default:
        break;
    }

    // Sort alphabetically
    return list.slice().sort((a, b) =>
      (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase())
    );
  }, [members, filter, workspaceId]);

  return (
    <>
      <Row className="mb-3">
        <Col sm={12}>
          <OutlineRoundedButtons
            active={filter}
            onChange={setFilter}
            workspaceOptions={workspaces}
            selectedWorkspace={workspaceId}
            onWorkspaceChange={setWorkspaceId}
          />
        </Col>
      </Row>

      <Row className="min-vh-50">
        {filteredMembers.length > 0 ? (
          filteredMembers.map(member => (
            <Col
              key={member.user_id}
              sm={12}
              lg={3}
              style={{ cursor: "pointer" }}
              onClick={() => handleMemberClick(member)}
            >
              <Congratulations data={member} />
            </Col>
          ))
        ) : (
          <Col
            xs={12}
            className="d-flex flex-column justify-content-center align-items-center text-center py-5"
            style={{ minHeight: "300px" }}
          >
            <div style={{ fontSize: "70px", opacity: 0.2 }}>
              📭
            </div>

            <h5 className="fw-semibold text-muted mt-3">
              No Data Available
            </h5>

            <p className="text-muted mb-0">
              There are no members in this category.
            </p>
          </Col>
        )}
      </Row>
    </>
  );
};

export default MyTeam;